<!--
  @description 操作日志
  @author xiehan
  @date 2018/12/17
-->
<template>
  <div class="logOperation__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true">
      <el-form-item :label="$t('logOperation.userName')" input-width="auto">
        <el-input v-model="searchForm.userName"></el-input>
      </el-form-item>
      <el-form-item :label="$t('logOperation.opModule')" input-width="auto">
        <el-input v-model="searchForm.opModule"></el-input>
      </el-form-item>
      <el-form-item :label="$t('logOperation.opType')" input-width="auto">
        <el-input v-model="searchForm.opType"></el-input>
      </el-form-item>
      <el-form-item :label="$t('logOperation.opTime')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.startTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.endTime" type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          v-g-rac="gRac('logOperation@search')"
          @click="search"
          v-text="$t('common.search')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
    border>
    </el-table-extend>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import table from '@/components/mixins/table'
  import logOperationBiz from '@/logic/systemSetting/logOperationBiz'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac, table],
    data () {
      return {
        searchForm: {
          startTime: new Date(new Date().toLocaleDateString()).getTime(),
          endTime: '',
          userName: '',
          opModule: '',
          opType: ''
        }
      }
    },
    methods: {
      initTable () {
        this.tInitTable({
          lanKey: 'logOperation.table',
          head: ['opTime', 'userName', 'opModule', 'opType', 'detail'],
          requestFun: this.searchTable
        })
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        if (!reqData.endTime) reqData.endTime = new Date().getTime()
        logOperationBiz.findPage(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.opTime = TimeFormat.getFormatTime(item.opTime)
            })
          }
          this.tData = data
        })
      }
    },
    mounted () {
      this.initTable()
      this.searchTable()
    }
  }
</script>